import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingtalkCircleFilledSvg from "@ant-design/icons-svg/es/asn/DingtalkCircleFilled";
import AntdIcon from '../components/AntdIcon';
var DingtalkCircleFilled = function DingtalkCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DingtalkCircleFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DingtalkCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DingtalkCircleFilled';
}
export default RefIcon;